'use client';

import { FC } from 'react';
import { usePathname } from '@/lib/router';
import { Navigation } from '@pcmp/react-coworker-components';
import LocationIcon from '@ingka/ssr-icon/paths/location-pin-small';
import { useTranslation } from 'react-i18next';
import { useMenuContext } from '@/components/layouts/page-layout/menu';
import { getSuperadminLocationsPath } from '@/lib/utils/router';

const { SideItemContainer } = Navigation;

export const SuperadminSideMenu: FC = () => {
  const { t } = useTranslation();
  const pathname = usePathname() || '';
  const { goTo } = useMenuContext();

  return (
    <>
      <SideItemContainer
        icon={LocationIcon}
        title={t('routes.superadminLocations')}
        active={pathname.startsWith('/superadmin/locations')}
        onClick={goTo(getSuperadminLocationsPath())}
      />
    </>
  );
};
